import { useEffect } from "react";
import {
  Menu,
  MenuItem,
  Grid,
  Box,
  ListItemIcon,
  ListItemText,
  FormControl,
  InputLabel,
  Select,
  CircularProgress,
} from "@mui/material";
import MaterialTable from "material-table";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import SendIcon from "@mui/icons-material/Send";
import { Tooltip } from "@mui/material";
import { useState } from "react";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import { GetAtsCompanyAction } from "../../../../../store/ATS/Company/Action";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAtsInvoiceAction,
  GetAtsInvoiceCandidatesAction,
  UpdateAtsInvoiceAction,
} from "../../../../../store/ATS/Invoice/Action";
import {
  ConvertDate,
  getImageSignedUrl,
  getUserData,
} from "../../../Base/helper/baseFunctions";
import ATSGeneratedInvoicePopup from "./ATSGeneratedInvoicePopup";
import AtsInvoicePdf from "./AtsInvoicePdf";
import { CSVLink } from "react-csv";
import Popup from "../../../Base/views/Popup";
import AtsInvoiceMail from "./AtsInvoiceMail";
import CustomToggle from "../../../Base/views/CustomToggle";
import { GetAtsGroupCompanyAction } from "../../../../../store/ATS/GroupCompany/Action";
import { pdf } from "@react-pdf/renderer";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";

const ClosedInvoiceTab = () => {
  const user = getUserData();
  const [imageUrl, setImageUrl] = useState("");
  const isGroupOrgFlowTrue = user?.grouporg_flow === true;
  const dispatch = useDispatch();
  const { atsCompanyData } = useSelector(
    (state) => state.AtsReducer?.AtsCompanyReducer,
  );
  const { atsGroupCompanyData } = useSelector(
    (state) => state.AtsReducer?.AtsGroupCompanyReducer,
  );
  const { letterHeadData } = useSelector(
    (state) => state?.AncillaryReducer?.LetterHeadReducer,
  );
  const { invoiceData, isInvoiceLoading } = useSelector(
    (state) => state.AtsReducer?.AtsInvoiceReducer,
  );
  const [currentData, setCurrentData] = useState({});
  const { invoiceCandidateData, isCandidateLoading } = useSelector(
    (state) => state.AtsReducer?.AtsInvoiceReducer,
  );
  const [candidateInvoiceData, setCandidateInvoiceData] = useState(
    invoiceData || [],
  );
  const [anchorEl, setAnchorEl] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [companyData, setCompanyData] = useState({ load: false, values: [] });
  const [atsgroupUser, setAtsGroupUser] = useState({
    load: true,
    values: [],
  });
  const [showGeneratedInvoice, setShowGeneratedInvoice] = useState(false);
  const [filters, setFilters] = useState({
    company_filter: "",
    days: 7,
    invoice_filter: toggle ? "Cancelled" : "Paid",
  });

  const [sendmail, setSendMail] = useState(false);
  const { featuresData } = useSelector(
    (state) => state?.RoleAndAccessReducer?.ATSModuleFeaturesReducer,
  );
  const { company_logo } = useSelector(
    (state) => state?.AncillaryReducer?.LetterHeadReducer,
  );
  const { company_config_data } = useSelector(
    (state) => state?.AncillaryReducer?.CompanyConfigReducer,
  );
  const headers = [
    { label: "Candidate Name", key: "first_name" },
    { label: "Job Title", key: "job_title" },
    { label: "Joined Date", key: "joined_date" },
    { label: "Billable CTC", key: "billable_ctc" },
  ];
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    dispatch(
      GetAtsInvoiceAction({
        status: toggle ? "Cancelled" : "Paid",
        ats_company_id: filters?.company_filter,
        past_days: filters?.days,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toggle]);

  useEffect(() => {
    isGroupOrgFlowTrue
      ? dispatch(GetAtsGroupCompanyAction())
      : dispatch(GetAtsCompanyAction());
    getImageSignedUrl(company_logo).then((url) => {
      setImageUrl(url);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setCandidateInvoiceData(invoiceData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceData]);

  const handleDisabled = (permission) => {
    const foundPermission = featuresData?.find(
      (item) => item.permission === permission,
    );
    return foundPermission ? true : false;
  };

  const handleFilter = (event, value) => {
    if (["company_filter"].includes(event)) {
      setFilters({ ...filters, [event]: value });
      dispatch(
        GetAtsInvoiceAction({
          status: toggle ? "Cancelled" : "Paid",
          ats_company_id: value,
          past_days: filters?.days,
        }),
      );
    } else if (["invoice_filter", "days"].includes(event?.target?.name)) {
      setFilters({ ...filters, [event?.target?.name]: event?.target?.value });
      dispatch(
        GetAtsInvoiceAction({
          status: toggle ? "Cancelled" : "Paid",
          ats_company_id: filters?.company_filter,
          past_days:
            event?.target?.name === "days"
              ? event?.target?.value
              : filters?.days,
        }),
      );
    }
  };

  const handleMoreVertIconClick = (event, rowData) => {
    setCurrentData(rowData);
    dispatch(
      GetAtsInvoiceCandidatesAction({
        ats_invoice_id: rowData?.ats_invoice_id,
      }),
    );
    setAnchorEl(event.currentTarget);
  };

  const handleMoreVertIconClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    setAnchorEl(false);
  };

  const [pdfLoading, setPdfLoading] = useState(false);

  const handleDownloadPdf = async () => {
    try {
      setPdfLoading(true);

      const blob = await pdf(
        <AtsInvoicePdf
          data={currentData}
          invoiceCandidateData={invoiceCandidateData}
          companylogo={imageUrl}
          letterHeadData={letterHeadData?.[0]}
          orgConfigData={company_config_data}
        />,
      ).toBlob();

      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `${currentData?.ats_invoice_no}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);

      setAnchorEl(null);
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setPdfLoading(false);
    }
  };

  const handleSendMail = () => {
    setAnchorEl(null);
    setSendMail(true);
  };
  const handleToggleoff = () => {
    setToggle((prev) => !prev);
    setFilters({
      company_filter: "",
      days: 7,
      invoice_filter: !toggle ? "Cancelled" : "Paid",
    }); // Clear the filters state
  };

  const handleGeneratedRowClick = (event, rowData) => {
    setCurrentData(rowData);
    dispatch(
      GetAtsInvoiceCandidatesAction({
        ats_invoice_id: rowData?.ats_invoice_id,
      }),
    );
    setShowGeneratedInvoice(true);
  };

  const handlePaidStatus = (status) => {
    dispatch(
      UpdateAtsInvoiceAction({
        ats_invoice_id: currentData?.ats_invoice_id,
        paid_status: status,
        status: "Paid",
        ats_company_id:
          +filters?.company_filter?.ats_company_id ||
          +filters?.company_filter?.ats_grouporg_id,
        past_days: filters?.days,
        paid_date: null,
        received_amount: currentData.received_amount || null,
        tds_amount: currentData?.tds_amount || null,
        final_invoice_amount: currentData?.invoice_amount || null
      }),
    );
    setAnchorEl(null);
    setOpenDialog(false);
  };
  return (
    <Box sx={{ maxHeight: "calc(100vh - 115px)", overflowY: "auto" }}>
      {showGeneratedInvoice && (
        <ATSGeneratedInvoicePopup
          setShowGeneratedInvoice={setShowGeneratedInvoice}
          currentData={{...currentData, ...(!toggle && {tabSection: "settled"})}}
          headers={headers}
          companylogo={imageUrl}
          letterHeadData={letterHeadData?.[0]}
        />
      )}
      <Box sx={{ mb: 1, mt: 1.5 }}>
        <Grid container columnSpacing={1}>
          <Grid item xs={12} sm={3}>
            {isGroupOrgFlowTrue ? (
              <SelectableSearch
                isOptionEqualToValue={(option, value) =>
                  +option.ats_grouporg_id === +value.ats_grouporg_id
                }
                label="Group Org"
                value={filters?.company_filter}
                loading={() =>
                  setAtsGroupUser({ load: false, values: atsGroupCompanyData })
                }
                fieldLabel="name"
                required={false}
                variant={"outlined"}
                name="company_filter"
                size="small"
                onChangeEvent={handleFilter}
                data={atsgroupUser}
              />
            ) : (
              <SelectableSearch
                isOptionEqualToValue={(option, value) =>
                  +option.ats_company_id === +value.ats_company_id
                }
                label="Client"
                value={filters?.company_filter}
                loading={() =>
                  setCompanyData({ load: false, values: atsCompanyData })
                }
                fieldLabel="name"
                required={false}
                variant={"outlined"}
                name="company_filter"
                size="small"
                onChangeEvent={handleFilter}
                data={companyData}
              />
            )}
          </Grid>
          <Grid item xs={12} sm={2}>
            <FormControl size="small" fullWidth>
              <InputLabel id="recruiter-type-select-label">Days</InputLabel>
              <Select
                name="days"
                labelId="days"
                id="days"
                value={filters?.days}
                label="Days"
                onChange={handleFilter}
              >
                <MenuItem value={7}>Last 7 Days</MenuItem>
                <MenuItem value={15}>Last 15 Days</MenuItem>
                <MenuItem value={30}>Last 30 Days</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
      <>
        <MaterialTable
          onRowClick={(event, rowData) =>
            handleGeneratedRowClick(event, rowData)
          }
          isLoading={isInvoiceLoading}
          columns={[
            {
              title: isGroupOrgFlowTrue ? "Group Org" : "Client",
              cellStyle: { padding: "10px 10px 10px 13px" },
              field: "company",
            },
            {
              title: "Invoice No",
              cellStyle: { padding: "10px 10px 10px 13px" },
              field: "ats_invoice_no",
            },
            {
              title: "Invoice Date",
              cellStyle: { padding: "10px 10px 10px 13px" },
              field: "invoice_date",
              render: (rowData) => {
                return ConvertDate(rowData?.invoice_date);
              },
            },
            {
              title: toggle ? "Cancelled Date" : "Paid Date",
              cellStyle: { padding: "10px 10px 10px 13px" },
              field: "paid_date",
              type: "date",
              render: (rowData) =>
                rowData?.paid_date ? ConvertDate(rowData?.paid_date) : "",
            },
            {
              title: "Invoice Amount",
              cellStyle: { padding: "5px 10px 5px 13px" },
              field: "gst_breakup",
              render: (rowData) =>
                Number(rowData?.gst_breakup?.candidate_total) || "0",
            },
            {
              title: "GST Total",
              cellStyle: { padding: "5px 10px 5px 13px" },
              field: "gst_total",
            },
            {
              title: "TDS",
              cellStyle: { padding: "5px 10px 5px 13px" },
              field: "tds_amount",
              render: (rowData) => Number(rowData?.tds_amount) || "0",
            },
            {
              title: "Total Amount",
              cellStyle: { padding: "5px 10px 5px 13px" },
              field: "invoice_amount",
            },
            {
              title: "Received Amount",
              cellStyle: { padding: "5px 10px 5px 13px" },
              field: "received_amount",
              render: (rowData) => Number(rowData?.received_amount) || "0",
              hidden: toggle
            },
          ]}
          data={candidateInvoiceData || []}
          options={{
            maxBodyHeight: "calc(100vh - 285px)",
            minBodyHeight: "calc(100vh - 285px)",
            rowStyle: { fontSize: "13px" },
            headerStyle: { padding: "0px 10px" },
            sorting: true,
            search: false,
            searchFieldAlignment: "right",
            searchAutoFocus: true,
            searchFieldVariant: "standard",
            filtering: false,
            paging: true,
            pageSizeOptions: [25, 50],
            pageSize: 25,
            selection: false,
            actionsColumnIndex: -1,
            actionsCellStyle: -1,
            grouping: false,
            addRowPosition: "first",
          }}
          title="Generated Invoice"
          actions={[
            ...(!toggle
              ? [
                  {
                    icon: () => <MoreVertIcon />,
                    position: "row",
                    tooltip: "More",
                    onClick: (_event, rowData) =>
                      handleMoreVertIconClick(_event, rowData),
                  },
                ]
              : []),
            {
              icon: () => (
                <CustomToggle
                  isChecked={toggle}
                  handleToggleChange={handleToggleoff}
                  Yestext={"Cancelled"}
                  NoText={"Settled"}
                  style={{
                    height: "32px",
                    padding: "0px",
                    width: "150px",
                    labelPadding: "2px",
                  }}
                />
              ),
              position: "row",
              isFreeAction: true,
              tooltip: toggle
                ? "Toggle to view settled invoice"
                : "Toggle to view cancelled invoice",
            },
          ]}
        />

        <Menu
          id="more-options-menu"
          anchorEl={anchorEl}
          open={anchorEl}
          onClose={handleMoreVertIconClose}
          MenuListProps={{
            "aria-labelledby": "more-options-button",
          }}
        >
          {isCandidateLoading ? (
            <MenuItem
              key="load"
              sx={{
                display: "flex",
                justifyContent: "center",
                minWidth: "180px",
              }}
            >
              <CircularProgress color="primary" />
            </MenuItem>
          ) : (
            <>
              <MenuItem key="download" onClick={() => handleEdit(currentData)}>
                <ListItemIcon>
                  {" "}
                  <SaveAltIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>
                  <CSVLink
                    style={{ color: "black" }}
                    data={invoiceCandidateData}
                    headers={headers}
                    filename={currentData?.ats_invoice_no}
                  >
                    Download CSV
                  </CSVLink>
                </ListItemText>
              </MenuItem>
              <MenuItem
                key="download pdf"
                onClick={handleDownloadPdf}
                disabled={pdfLoading}
              >
                <ListItemIcon>
                  {pdfLoading ? (
                    <CircularProgress size={18} disableShrink />
                  ) : (
                    <SaveAltIcon fontSize="small" />
                  )}
                </ListItemIcon>
                <ListItemText>
                  {pdfLoading ? "Generating..." : "Download PDF"}
                </ListItemText>
              </MenuItem>
              <MenuItem key="sendmail" onClick={handleSendMail}>
                <ListItemIcon>
                  {" "}
                  <SendIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Send Mail</ListItemText>
              </MenuItem>
              <Tooltip
                title={
                  handleDisabled("invoice_generated_invoice_payment")
                    ? "You Don't have sufficient permission. Please contact Admin."
                    : ""
                }
              >
                <span>
                  <MenuItem
                    key="paid-action"
                    onClick={() => {setOpenDialog(true); setAnchorEl(null);}}
                    disabled={handleDisabled(
                      "invoice_generated_invoice_payment",
                    )}
                  >
                    <ListItemIcon>
                      {" "}
                      <CreditCardIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Mark as UnPaid</ListItemText>
                  </MenuItem>
                </span>
              </Tooltip>
            </>
          )}
        </Menu>
      </>
      <Popup
        title={currentData?.ats_invoice_no}
        openPopup={sendmail}
        setOpenPopup={setSendMail}
        maxWidth={"md"}
        fullWidth={true}
      >
        <AtsInvoiceMail
          setSendMail={setSendMail}
          currentData={currentData}
          invoiceCandidateData={invoiceCandidateData}
          companylogo={imageUrl}
          letterHeadData={letterHeadData?.[0]}
          orgConfigData={company_config_data}
        />
      </Popup>
      <ConfirmationDialog
            title={`Mark as UnPaid Invoice ${currentData?.ats_invoice_no}`}
            content={"Are you sure you want to proceed?"}
            openDialog={openDialog}
            closeDialog={setOpenDialog}
            OkButtonText="Yes"
            onSubmit={() => handlePaidStatus("Not Paid")}
        />
    </Box>
  );
};

export default ClosedInvoiceTab;
